<template>
  <div class="content if-profile report-tab">
    <div class="md-layout ratios-report">
      <MRReportHeader :headerData="this.headerData" />

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 marketprof-competitors p-0 mt-4"
      >
        <!-- <div class="finanical-report-messages">
          <h1 class="md-subheading profile-title">Average Annual Sales</h1>
          <div class="">
            <md-dialog :md-active.sync="showDialog">
              <p>
                What is the total size of the industry market? How much is
                captured by small businesses and startups? <br />
                <br />
                Industry Market Volume represents sales of all industry
                operations in the area. Small Business Market Volume represents
                only those firms with fewer than 25 employees. Startup volume is
                calculated for firms in operation for less than two years.
                <br />
                <br />

                Market volume and average firm sales calculations are developed
                with firm-level data which is integrated with Bizminer's
                internally generated Sales per Employee projections. SPE data is
                both industry- and location-specific, and is updated monthly by
                the application of US Census data and five industry and consumer
                price and productivity indices from the Bureau of Labor
                Statistics and other federal agencies.
        </p>-->
        <!-- <p>How do your sales rank among the competition? This section shows the answer in three ways. <br> <br>
                Your absolute sales rank is shown in “x of x” format.<br> <br>
                Your percentile rank calculates the percentage of competitors with sales that fall below yours.<br> <br>
                Your variance from median indicates the percentage level of your annual sales relative to median sales– the level at which the number of operations above and below is the same.
        </p>-->
        <!-- </md-dialog>
            <md-card-header class="md-card-header-icon messages-box">
              <div class="card-icon md-ripple" @click="showDialog = true">
                <md-icon class="icon-arrow">double_arrow</md-icon>
                <md-icon>chat_bubble</md-icon>
              </div>
            </md-card-header>
          </div>
        </div>-->
        <div class="navbar md-toolbar md-transparent md-elevation-4 finanical-report-messages p-0">
          <nav-tabs-card no-label md-elevation="0">
            <template slot="content">
              <md-tabs md-alignment="left" class="if_card">
                <md-tab md-label="Avg Sales" md-icon="equalizer" class="p-0">
                  <md-card class="m-0">
                    <md-card-header>Average Annual Sales</md-card-header>
                    <md-card-content>
                      <div class="md-layout p-4">
                        <!--<div class="md-layout-item md-medium-size-100 md-size-100">
                          <md-card class="md-card-profile">
                            <md-card-header>
                              <h4 class="title m-0">
                                <div
                                  class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                >ABC Plumbing Competitive Sales Analysis</div>
                              </h4>
                            </md-card-header>
                            <md-card-content>
                              <div class="extra_space">
                                  ABC Plumbing Competitive Sales Analysis
                                <p>
                                  <edited>
                                    ABC Plumbing sales for the 12 months ending
                                    October 2017 were $1,526,355. Company annual
                                    sales have increased by 1.00% in the three
                                    calendar years since 2015.
                                  </edited>
                                  <br />
                                  <br />As of October 2017 company annualized sales
                                  vary from the local industry average by
                                  21.09%.
                                  <br />
                                  <br />Variance from the small business bracket
                                  average is higher at 110.28%, while variance
                                  from median site sales is 157.70%. The
                                  variance from median indicates the percentage
                                  level of annual sales relative to median
                                  sales—the level at which the number of
                                  operations above and below is the same.
                                </p>
                              </div>
                            </md-card-content>
                          </md-card>
                        </div>-->
                        <div class="md-layout-item md-size-100  blue-tbl">
                          <md-card class="md-card-profile">
                            <md-card-header class="md-card-header-icon">
                              <h4 class="title m-0">
                                <div
                                  class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                >Average Annual Sales ($)</div>
                              </h4>
                              <!-- <h4 class="title text-left">
                                Average Annual Sales ($)
                              </h4>-->
                            </md-card-header>
                            <md-card-content>
                              <div class="md-layout">
                                <div
                                  class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                                >
                                  <md-table
                                    v-model="tableDataMarketAnnualSales"
                                    table-header-color="blue"
                                    class="profit-and-loss-table"
                                  >
                                    <md-table-row>
                                      <md-table-head></md-table-head>
                                      <md-table-head v-for="head in annualSalesCols" :key="head">
                                        <div class="md-table-head-label" v-html="head"></div>
                                      </md-table-head>
                                    </md-table-row>

                                    <md-table-row
                                      v-for="(item,
                                      index) in tableDataMarketAnnualSales"
                                      :key="index"
                                    >
                                      <md-table-cell class="md-table-side-label">{{ item.name }}</md-table-cell>
                                      <md-table-cell
                                        v-for="key in Object.keys(item.dates)"
                                        :key="key"
                                      >{{ key==4 ?item.dates[key]+'%':'$'+item.dates[key] }}</md-table-cell>
                                    </md-table-row>
                                  </md-table>
                                </div>
                              </div>
                            </md-card-content>
                          </md-card>
                        </div>
                        <div class="md-layout-item md-medium-size-100 md-size-50">
                          <md-card class="md-card-profile">
                            <md-card-content>
                              <chart-card
                                header-animation="false"
                                :chart-data="colouredLineChart.data"
                                :chart-options="colouredLineChart.options"
                                chart-type="Line"
                                header-icon
                                chart-inside-content
                                no-footer
                                background-color="blue"
                              >
                                <template slot="chartInsideHeader">
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >
                                      {{ release_display }} Average Annual Sales
                                      ($)
                                    </div>
                                  </h4>
                                  <!-- <h4 class="title">
                                    {{ release_display }} Average Annual Sales ($)
                                  </h4>-->
                                </template>
                              </chart-card>
                              <div class="pie-line">
                                <ul>
                                  <li><span class=""><i class="fa fa-square green-color"></i></span> Average Site</li>
                                    <li><span class=""><i class="fa fa-square sky-blue-color"></i></span> Median Site</li>
                                    <li><span class=""><i class="fa fa-square red-color"></i></span> Small Business</li>
                                     <li><span class=""><i class="fa fa-square yellow-color"></i></span> Startups</li>
                                     <li><span class=""><i class="fa fa-square blue-color"></i></span> Your Firm</li>
                                </ul>
                                    </div>
                            </md-card-content>
                          </md-card>
                        </div>
                       <div class="md-layout-item md-medium-size-100 md-size-50">
                          <md-card class="md-card-profile">
                            <md-card-header>
                              <h4 class="title m-0">
                                <div
                                  class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                >
                                  Competitive Market Narrative
                                </div>
                              </h4>
                            </md-card-header>
                            <md-card-content>
                              <div class="extra_space">
                                <!-- <h4 class="Performance Scores">
                                  Competitive Market Narrative
                                </h4> -->
                                <p>
                                  {{cmnText.annualSales.average}}<br><br>
                                  {{cmnText.annualSales.averageTop}}
                                </p>
                              </div>
                            </md-card-content>
                          </md-card>

                          <md-card class="md-card-profile">
                            <md-card-header>
                              <h4 class="title m-0">
                                <div
                                  class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                >
                                  <md-icon class="color-white">article</md-icon> Annual Sales
                                </div>
                              </h4>
                            </md-card-header>
                            <md-card-content>
                              <div class="md-layout">
                                <div class="md-layout-item md-medium-size-100 md-size-100">
                                  <div class="extra_space">
                                    <!-- <h4 class="Performance Scores">
                                          Competitive Market Narrative
                                    </h4>-->
                                    <p>
                                      What are the average annual sales of all industry sites, small businesses and startups in this market?
                                      Median sales are also displayed to avoid distortion of averages by unusually large firms.
                                      If you made the necessary inputs, your firm sales are benchmarked.<br><br> Small business sales represent firms with  &lt;25
                                      employees. Startup sales are calculated for firms in operation for less than two years. <br><br>Market
                                      volume and average firm sales calculations are developed with firm‐level data which is integrated
                                      with BizMiner’s internally generated Sales per Employee projections. SPE data is both industry‐ and
                                      location‐specific, and is updated monthly by the application of US Census data and five industry and
                                      consumer price and productivity indices from the Bureau of Labor Statistics and other federal agencies.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </md-card-content>
                          </md-card>
                        </div>
                        <div class="md-layout-item md-medium-size-100 md-size-50">

                     </div>

                      </div>
                    </md-card-content>
                  </md-card>
                </md-tab>
                <md-tab md-label="Sales Rank" md-icon="verified" class="p-0">
                  <md-card class="m-0">
                    <md-card-header>Sales Rank</md-card-header>
                    <md-card-content>
                      <div class="md-layout p-4">
                        <!--<div class="md-layout-item md-medium-size-100 md-size-100">
                          <md-card class="md-card-profile">
                            <md-card-header>
                              <h4 class="title m-0">
                                <div
                                  class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                >ABC Plumbing Competitive Sales Rank Analysis</div>
                              </h4>
                            </md-card-header>
                            <md-card-content>
                              <div class="extra_space">

                                  ABC Plumbing Competitive Sales Rank Analysis

                                <p>
                                  ABC Plumbing sales rank 103 of 763 industry
                                  operations in the market area, giving the firm
                                  a 87 percentile rating (the percentage of
                                  competitors with sales that fall below ABC
                                  Plumbing sales). ABC Plumbing holds a 0.16%
                                  share of market sales, which increased 0.01
                                  percentage points since 2015.
                                </p>
                              </div>
                            </md-card-content>
                          </md-card>
                        </div>-->
                        <div class="md-layout-item md-size-100  blue-tbl">
                          <md-card class="md-card-profile">
                            <md-card-header>
                              <h4 class="title m-0">
                                <div
                                  class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                >Annual Sales Rank</div>
                              </h4>
                            </md-card-header>
                            <md-card-content>
                              <div
                                class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                              >
                                <md-table
                                  v-model="tableDataSalesRank"
                                  table-header-color="blue"
                                  class="profit-and-loss-table"
                                >
                                  <md-table-row>
                                    <md-table-head></md-table-head>
                                    <md-table-head v-for="head in annualSalesRankCols" :key="head">
                                      <div class="md-table-head-label" v-html="head"></div>
                                    </md-table-head>
                                  </md-table-row>

                                  <md-table-row
                                    v-for="(item, index) in tableDataSalesRank"
                                    :key="index"
                                  >
                                    <md-table-cell class="md-table-side-label">{{ item.name }}</md-table-cell>
                                    <md-table-cell
                                      v-for="key in Object.keys(item.dates)"
                                      :key="key"
                                    >{{ item.dates[key] }}</md-table-cell>
                                  </md-table-row>
                                </md-table>
                              </div>
                            </md-card-content>
                          </md-card>
                        </div>
                        <div class="md-layout-item md-medium-size-100 md-size-100">
                          <md-card class="md-card-profile">
                            <md-card-content>
                              <chart-card
                                header-animation="false"
                                :chart-data="colouredLineChart.data"
                                :chart-options="colouredLineChart.options"
                                chart-type="Line"
                                header-icon
                                chart-inside-content
                                no-footer
                                background-color="blue"
                              >
                                <template slot="chartInsideHeader">
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >
                                      {{ release_display }} Average Annual Sales
                                      ($)
                                    </div>
                                  </h4>
                                  <!-- <h4 class="title">
                                    {{ release_display }} Average Annual Sales ($)
                                  </h4>-->
                                </template>
                              </chart-card>
                              <div class="pie-line">
                                <ul>
                                  <li><span class=""><i class="fa fa-square green-color"></i></span> Sales Rank</li>
                                    <li><span class=""><i class="fa fa-square sky-blue-color"></i></span> Sales Percentile</li>
                                    <li><span class=""><i class="fa fa-square blue-color"></i></span> Variance from Average Sales (%)</li>
                                     <li><span class=""><i class="fa fa-square yellow-color"></i></span> Variance from Median Sales (%)</li>

                                </ul>
                                    </div>
                            </md-card-content>
                          </md-card>
                        </div>
                      </div>
                    </md-card-content>
                  </md-card>
                </md-tab>
              </md-tabs>
            </template>
          </nav-tabs-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ChartCard, NavTabsCard } from '@/components';
import { mapState } from 'vuex';
import MRReportHeader from './_partials/MRReportHeader.vue';

export default {
  components: {
    ChartCard,
    NavTabsCard,
    MRReportHeader,
  },
  computed: {
    ...mapState({
      annualSales: (state) => state.user.market_report.data.data['annualSales'],
      annualSalesCols: (state) =>
        state.user.market_report.data['annualSalesCols'],
      annualSalesRank: (state) =>
        state.user.market_report.data.data['annualSalesRank'],
      annualSalesRankCols: (state) =>
        state.user.market_report.data['annualSalesRankCols'],
      years: (state) => state.user.market_report.data.years,
      release_display: (state) =>
        state.user.market_report.data.general['release_display'],
      cmnText: (state) =>state.user.market_report.cmnText,
    }),
  },
  props: ['headerData'],
  data() {
    return {
      view: 'cash-flow-solvency',
      showDialog: false,
      tableDataMarketAnnualSales: [],
      tableDataSalesRank: [],
      colouredLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 80,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: '300px',
        },
      },
    };
  },
  mounted() {
    let section = this.$route.query.section;

    if (!section) {
      section = 'cash-flow-solvency';
    }

    this.switchView(section);
    this.tableDataMarketAnnualSales = Object.entries(this.annualSales).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    let me = this;
    this.tableDataMarketAnnualSales.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithCommas(e);
      });
      return item;
    });
    this.tableDataSalesRank = Object.entries(this.annualSalesRank).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    let newTableAnnualSales = Object.entries(this.annualSales).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    newTableAnnualSales.map((item) => {
      item.dates = item.dates.map((e) => {
        return Math.round(Number(e)) / 1000000;
      });
      return item;
    });
    this.colouredLineChart.data = {
      labels: this.years,
      series: newTableAnnualSales.map((item) => ({
        name: item.name,
        data: item.dates.map(function (el, index) {

          if (index != 4)
            return el;
        }
        ),
      })),
    };
  },
  watch: {
    '$route.query.section'() {
      let section = this.$route.query.section;

      if (!section) {
        section = 'cash-flow-solvency';
      }

      this.switchView(section);
    },
  },
  methods: {
    switchView: function (type) {
      this.view = type;
    },
    numberWithCommas(x) {
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      } else {
        return x;
      }
    },
  },
};
</script>
<style lang="scss">
.marketprof-competitors {
  .md-toolbar {
    .md-collapse {
      display: block;

      .md-collapse-content {
        p {
          padding-left: 20px;
        }
      }
    }
  }

  .competitors-list {
    .md-collapse-title {
      font-size: 12px;
      font-weight: 300;
      margin-left: 25px;
    }

    .md-icon {
      font-size: 12px;
      font-weight: 300;
      transform: rotate(-90deg);
      left: 0;
      color: rgba(0, 0, 0, 0.54);
    }
  }

  .competitors-map {
    iframe {
      height: 300px !important;
    }
  }
}
</style>
